import React from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from '@mui/icons-material';
import Button from '@ui-lib/components/Button';
import { useModal } from '@web-shared/hooks';
import { EBOL_STATUS } from '../../../../../api/types/EbolStatus';
import EbolActionModal from './EbolActionModal';
import { EbolActionProps } from './EbolActionModal/types';

const AcceptWithDiscrepanciesButton = (props: EbolActionProps) => {
  const { t } = useTranslation();
  const [open, handleModal] = useModal();

  return <>
    <Button 
      color="secondary" 
      variant='tonal' 
      startIcon={<Rule />}
      onClick={handleModal}
      fullWidth
    >
      {t('label_acceptWithDiscrepancies')}
    </Button>
    <EbolActionModal 
      open={open} 
      onClose={handleModal}
      status={EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES}
      {...props} />
  </>;
};

export default AcceptWithDiscrepanciesButton;